import { render, staticRenderFns } from "./CategoryCreateEdit.vue?vue&type=template&id=0c219722&"
import script from "./CategoryCreateEdit.vue?vue&type=script&lang=js&"
export * from "./CategoryCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports